import { combineReducers } from 'redux'
import homeReducer from './homeReducer'
import categoryReducer from './categoryReducer'
import productReducer from './productReducer'
import shoppingCartReducer from './shoppingCartReducer'
import cityReducer from './cityReducer';
import shippingDetailsReducer from './shippingDetailsReducer';
import addressNomenclatureReducer from './addressNomenclatureReducer'
import termsReducer from './termsReducer';
import themeReducer from './themeReducer';
import displayRouteReducer from './displayRouteReducer';
import categoryDetailReducer from "./categoryDetailReducer";
import purchaseReducer from "./purchaseReducer";
import elogisticaReducer from "./elogisticaReducer";
import countryReducer from './countryReducer'
import aveonlineReducer from './aveonlineReducer'
import clientIdReducer from './clientIdReducer'
import marcaBlancaReducer from './marcaBlancaReducer'

const rootReducer = combineReducers({
  home: homeReducer,
  category: categoryReducer,
  product: productReducer,
  shoppingCart: shoppingCartReducer,
  shippingDetails: shippingDetailsReducer,
  addressNomenclature: addressNomenclatureReducer,
  city: cityReducer,
  country: countryReducer,
  termsConditions : termsReducer,
  theme: themeReducer,
  displayRoute: displayRouteReducer,
  categoryDetail: categoryDetailReducer,
  purchase: purchaseReducer,
  elogistica: elogisticaReducer,
  aveonline: aveonlineReducer,
  client: clientIdReducer,
  marcaBlanca: marcaBlancaReducer
})

export type RootState = ReturnType<typeof rootReducer>
export default rootReducer
